import React, { useState } from "react";

import {
    createCapitulo,
    deleteCapitulo,
    updateCapitulo
} from "../../services/firebase/firestore";


const AdminCapituloForm = ({
    capitulo = null,
    onClose,
    onSaved,
    onDeleted
}) => {

    const isNew = !capitulo;


    const [capituloId, setCapituloId] = useState(
        capitulo?.id || ""
    );


    const [form, setForm] = useState({
        capitulo: capitulo?.capitulo || "",
        titulo: capitulo?.titulo || "",
        img: capitulo?.img || "",
        link: capitulo?.link || ""
    });


    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);


    const handleChange = (e) => {

        const { name, value } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: value
        }));

    };


    const cleanId = (value) => {

        return value
            .trim()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-_]/g, "");

    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        setSaving(true);
        setError("");
        setSuccess(false);

        try {

            if (isNew) {

                const id = cleanId(capituloId);

                if (!id) {
                    setError("Tenés que ingresar un ID para el capítulo.");
                    return;
                }


                await createCapitulo(
                    id,
                    form
                );


                if (onSaved) {
                    onSaved({
                        id,
                        ...form
                    });
                }

            } else {

                await updateCapitulo(
                    capitulo.id,
                    form
                );


                if (onSaved) {
                    onSaved({
                        ...capitulo,
                        ...form
                    });
                }

            }


            setSuccess(true);


        } catch (error) {

            console.error(error);

            if (error.message === "capitulo-exists") {

                setError(
                    "Ya existe un capítulo con ese ID."
                );

            } else {

                setError(
                    isNew
                        ? "No se pudo crear el capítulo."
                        : "No se pudieron guardar los cambios."
                );

            }

        } finally {

            setSaving(false);

        }

    };


    const handleDelete = async () => {

        if (!capitulo) {
            return;
        }


        const confirmed = window.confirm(
            `¿Seguro que querés eliminar "${capitulo.capitulo || capitulo.id}"?\n\nEsta acción no se puede deshacer.`
        );


        if (!confirmed) {
            return;
        }


        setDeleting(true);
        setError("");


        try {

            await deleteCapitulo(capitulo.id);

            if (onDeleted) {
                onDeleted(capitulo.id);
            }

        } catch (error) {

            console.error(error);

            setError(
                "No se pudo eliminar el capítulo."
            );

        } finally {

            setDeleting(false);

        }

    };


    return (
        <div className="admin-edit">

            <div className="admin-section-title">

                <h2>
                    {isNew
                        ? "Agregar capítulo"
                        : `Editar ${capitulo.capitulo}`
                    }
                </h2>

                <button
                    type="button"
                    onClick={onClose}
                >
                    Volver
                </button>

            </div>


            <form
                className="admin-form"
                onSubmit={handleSubmit}
            >

                <div className="admin-form-group">

                    <label>
                        ID
                    </label>

                    <input
                        type="text"
                        value={capituloId}
                        onChange={(e) =>
                            setCapituloId(e.target.value)
                        }
                        disabled={!isNew}
                        placeholder="capitulo6"
                        required
                    />

                    <small>
                        Ejemplo: <strong>capitulo6</strong>
                    </small>

                </div>


                <div className="admin-form-row">

                    <div className="admin-form-group">

                        <label>
                            Capítulo
                        </label>

                        <input
                            type="text"
                            name="capitulo"
                            value={form.capitulo}
                            onChange={handleChange}
                            placeholder="CAPÍTULO 6"
                            required
                        />

                    </div>


                    <div className="admin-form-group">

                        <label>
                            Título
                        </label>

                        <input
                            type="text"
                            name="titulo"
                            value={form.titulo}
                            onChange={handleChange}
                            placeholder="PYRO"
                            required
                        />

                    </div>

                </div>


                <div className="admin-form-group">

                    <label>
                        Imagen
                    </label>

                    <input
                        type="text"
                        name="img"
                        value={form.img}
                        onChange={handleChange}
                        placeholder="capitulo-06.jpg"
                        required
                    />

                    <small>
                        Nombre del archivo de imagen alojado en la web.
                    </small>

                </div>


                <div className="admin-form-group">

                    <label>
                        Link
                    </label>

                    <input
                        type="url"
                        name="link"
                        value={form.link}
                        onChange={handleChange}
                        placeholder="https://..."
                        required
                    />

                </div>


                {error &&
                    <p className="admin-error">
                        {error}
                    </p>
                }


                {success &&
                    <p className="admin-success">
                        {isNew
                            ? "Capítulo creado correctamente."
                            : "Cambios guardados correctamente."
                        }
                    </p>
                }


                <div className="admin-form-actions">

                    <button
                        type="submit"
                        disabled={saving || deleting}
                    >
                        {saving
                            ? "Guardando..."
                            : isNew
                                ? "Crear capítulo"
                                : "Guardar cambios"
                        }
                    </button>


                    {!isNew &&
                        <button
                            type="button"
                            className="admin-delete"
                            onClick={handleDelete}
                            disabled={saving || deleting}
                        >
                            {deleting
                                ? "Eliminando..."
                                : "Eliminar capítulo"
                            }
                        </button>
                    }

                </div>

            </form>

        </div>
    );

};


export default AdminCapituloForm;